import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  Folder as FileIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import AccountNotesTable from "modules/notes/components/AccountNotesTable";
import { getDisplayCreatorName } from "utils/noteUtils";

const NotesSection = React.memo(function NotesSection({ expanded, onToggle }) {
  const notes = useSelector((state) => state.notes);

  return (
    <Accordion
      expanded={expanded}
      onChange={onToggle}
      elevation={1}
      sx={{
        borderRadius: 2,
        "&:before": { display: "none" },
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: "grey.50",
          borderRadius: "8px 8px 0 0",
          "&.Mui-expanded": { borderRadius: "8px 8px 0 0" },
        }}
      >
        <Box display="flex" alignItems="center" gap={2} sx={{ width: "100%" }}>
          <Box display="flex" alignItems="center" gap={2} sx={{ flex: 1 }}>
            <FileIcon color="primary" />
            <Typography variant="h5" fontWeight="600">
              Notes & Communication
            </Typography>
            {!notes.isLoading && notes.data && notes.data.length > 0 && (
              <Box sx={{ ml: 2 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.75rem" }}
                >
                  Last:{" "}
                  {(() => {
                    const lastNote = notes.data[0];
                    const noteDate = new Date(lastNote.created);
                    return `${noteDate.toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })} by ${getDisplayCreatorName(lastNote.creatorName)}`;
                  })()}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.primary"
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 500,
                    maxWidth: 300,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {notes.data[0].note || "No note content"}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <AccountNotesTable />
      </AccordionDetails>
    </Accordion>
  );
});

export default NotesSection;
